module.exports = __webpack_public_path__ + "static/media/member-banner.0a0254ff.svg";